export default __webpack_public_path__ + "static/unboxing-afe130688800cbaef56284f0441a2f15.png";